import { ALERT } from './types'

export function Alert(messageType) {
  return {
    type: ALERT,
    payload: messageType,
  }
}
